import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { StarRatingColor } from './interfaces/stars-rating.interface';

@Component({
  selector: 'tic-stars-rating',
  templateUrl: './stars-rating.component.html',
  styleUrls: ['./stars-rating.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
})
export class StarsRatingComponent implements OnInit {
  @Input() rating;
  @Input() starCount = 5;
  @Input() starsColor: StarRatingColor = StarRatingColor.accent;
  @Input() clickAbleStar = false;
  @Output() ratingUpdated: EventEmitter<number> = new EventEmitter();
  ratingArr = [] as any;

  constructor() { }

  ngOnInit() {
    this.setRatingArr();
  }

  private setRatingArr() {
    for (let index = 0; index < this.starCount; index++) {
      this.ratingArr.push(index);
    }
  }

  onStarClick(rating: number): void {
    this.rating = rating;
    this.ratingUpdated.emit(rating);
  }
}
